module.exports = __webpack_public_path__ + "img/d.43694f36.jpg";